import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Icon } from '../Icon';

const quoteIconSx = {
  position: 'absolute',
  fontSize: '3rem',
  p: '0 0.5rem',
} as const;

interface QuoteProps {
  children: ReactNode;
  author?: string;
  title?: string;
}
export const Quote = ({ children, author, title }: QuoteProps) => (
  <Stack
    sx={{
      gap: '1rem',
      border: 'none',
      p: '1.5rem 1rem',
      m: '1.5rem 0',
      position: 'relative',
      typography: 'bodyMd',
      color: '#000000',
    }}
  >
    <Box sx={{ ...quoteIconSx, top: '-1.5rem', left: '0.5rem' }}>
      <Icon icon='quote-left' type='fas' />
    </Box>
    {children}
    {(author || title) && (
      <Stack sx={{ alignItems: 'flex-end' }}>
        <strong>{author}</strong>
        {title}
      </Stack>
    )}
    <Box sx={{ ...quoteIconSx, bottom: '-1.5rem', right: '0.5rem' }}>
      <Icon icon='quote-right' type='fas' />
    </Box>
  </Stack>
);

export default Quote;
